<template>
  <div v-clipboard:copy="data"
       v-clipboard:success="onCopy"
       v-clipboard:error="onError">
    <span class="address-box-copy-icon"><img src="../../images/address/copy.png"/></span>
  </div>
</template>

<script>
export default {
name: "copy",
  props:[
      'data'
  ],
  data () {
    return {
    }
  },
  methods: {
    onCopy: function () {
      this.$toast('Copy Successfully')
    },
    onError: function () {
      this.$toast('Copy Failed')
    }
  }
}
</script>

<style scoped>

</style>
